import {Outlet, useLocation, useNavigate} from "react-router";
import {useEffect} from "react";
import {linkLogin} from "app/nav/links";
import {useGlobalState} from "app/user/GlobalStateProvider";
import {RETURN_TO_PARAM} from "app/util/constants";

export const AuthWrapper = () => {
  const {isLoggedIn} = useGlobalState();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      const searchParams = new URLSearchParams();
      searchParams.set(RETURN_TO_PARAM, location.pathname + location.search + location.hash);
      navigate(`${linkLogin()}?${searchParams.toString()}`);
    }
  }, [isLoggedIn, location.hash, location.pathname, location.search, navigate]);

  return isLoggedIn ? <Outlet /> : null;
};
